// Waitlist feedback: Norwegian invalid-email message on every waitlist field, and a 4s toast after a successful signup.
const INVALID_SELECTOR = 'input[data-invalid-message]';

document.addEventListener('invalid', (event) => {
  const field = event.target;
  if (!(field instanceof HTMLInputElement) || !field.matches(INVALID_SELECTOR)) return;
  if (field.validity.valueMissing || field.validity.typeMismatch) field.setCustomValidity(field.dataset.invalidMessage);
}, true);

document.addEventListener('input', (event) => {
  const field = event.target;
  if (field instanceof HTMLInputElement && field.matches(INVALID_SELECTOR)) field.setCustomValidity('');
});

// Shopify redirects a posted customer form back with ?customer_posted=true#<form id>.
const params = new URLSearchParams(location.search);
const toast = document.getElementById('waitlist-toast');

if (toast && params.has('customer_posted') && !window.Shopify?.designMode) {
  toast.hidden = false;
  // Set the text after un-hiding so screen readers announce it.
  requestAnimationFrame(() => { toast.textContent = toast.dataset.message; });
  setTimeout(() => { toast.hidden = true; }, 4000);

  // A refresh should not replay the toast; the anchor keeps the visitor at the form.
  params.delete('customer_posted');
  const query = params.toString();
  history.replaceState(history.state, '', `${location.pathname}${query ? `?${query}` : ''}${location.hash}`);
}
